(() => {
 const messages = ['2 ARTIKEL: 10 % EXTRA RABATT','3 ARTIKEL: 15 % EXTRA RABATT','4 ARTIKEL: 20 % EXTRA RABATT','5+ ARTIKEL: 25 % EXTRA RABATT'];
 const motion = matchMedia('(prefers-reduced-motion: reduce)');
 function init(root) {
  if(root.dataset.epReady) return;
  root.dataset.epReady='true';
  let slides=[...root.querySelectorAll('[data-ms-ann-slide]')];
  if(!slides.length){
  const viewport=document.createElement('div');
  viewport.className='ep-tier-announcement__viewport';
  slides=messages.map((message,index) => {
   const slide=document.createElement('span');
   slide.className='ep-tier-announcement__slide';slide.textContent=message;
   slide.setAttribute('role','group');slide.setAttribute('aria-label',`${index+1} von ${messages.length}`);
   viewport.append(slide);return slide;
  });
  root.replaceChildren(viewport);root.setAttribute('aria-live','off');
  }
  root.dataset.initialized='true';
  let index=0,timer,paused=false;
  const show = () => slides.forEach((slide,i)=>{slide.classList.toggle('is-active',i===index);slide.setAttribute('aria-hidden',String(i!==index))});
  const schedule = () => {clearTimeout(timer);if(!paused&&!motion.matches) timer=setTimeout(()=>{index=(index+1)%slides.length;show();schedule()},5000)};
  root.addEventListener('mouseenter',()=>{paused=true;clearTimeout(timer)});
  root.addEventListener('mouseleave',()=>{paused=false;schedule()});
  motion.addEventListener('change',schedule);
  document.addEventListener('visibilitychange',()=>{if(document.hidden)clearTimeout(timer);else schedule()});
  document.addEventListener('shopify:section:unload',event=>{if(event.target.contains(root))clearTimeout(timer)});
  show();schedule();
 }
 document.querySelectorAll('[data-ep-tier-announcement],[data-ms-auto-announcement]').forEach(init);
 document.addEventListener('shopify:section:load',()=>document.querySelectorAll('[data-ep-tier-announcement],[data-ms-auto-announcement]').forEach(init));
})();
